import { render, staticRenderFns } from "./ServerLists.vue?vue&type=template&id=268bdd69&scoped=true&"
import script from "./ServerLists.vue?vue&type=script&lang=js&"
export * from "./ServerLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268bdd69",
  null
  
)

export default component.exports